// Normalize CMS palette data; never generate colors from a seed.
export function normalizePackageColor(value) {
	if (typeof value !== 'string') return '';
	const match = value.trim().match(/^#?([a-f\d]{6})$/i);
	return match ? `#${match[1].toUpperCase()}` : '';
}

export function initPackageColors(root = document) {
	root.querySelectorAll('.single-goi-san-pham .package-theme-scope').forEach((scope) => {
		for (let number = 1; number <= 12; number++) {
			const property = `--pkg-color-${number}`;
			const raw = scope.style.getPropertyValue(property);
			if (!raw) continue;
			const normalized = normalizePackageColor(raw);
			if (normalized) scope.style.setProperty(property, normalized, scope.style.getPropertyPriority(property));
			else scope.style.removeProperty(property);
		}
	});
}
